import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./FileClaim.css";

const CLAIM_TYPES = [
  "Purchase Protection",
  "Extended Warranty",
  "Trip Insurance",
  "Emergency Medical",
];

export default function FileClaim() {
  const [form, setForm] = useState({
    claimType: "",
    itemDescription: "",
    amount: "",
    incidentDate: "",
    files: null,
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === "file" ? files : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };

  if (submitted) {
    return (
      <div className="file-claim-page">
        <header className="file-claim-header">
          <Link to="/insurance" className="file-claim-back" aria-label="Back to insurance">
            ←
          </Link>
        </header>
        <div className="file-claim-success">
          <span className="success-icon">✓</span>
          <h2>Claim submitted successfully</h2>
          <p>We&apos;ll review your claim and get back to you within 7 business days.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="file-claim-page">
      <header className="file-claim-header">
        <Link to="/insurance" className="file-claim-back" aria-label="Back to insurance">
          ←
        </Link>
      </header>

      <h1 className="file-claim-title">File a Claim</h1>

      <form className="file-claim-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="claimType">Claim Type</label>
          <select
            id="claimType"
            name="claimType"
            value={form.claimType}
            onChange={handleChange}
            required
          >
            <option value="">Select type...</option>
            {CLAIM_TYPES.map((type) => (
              <option key={type} value={type}>
                {type}
              </option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label htmlFor="itemDescription">Item Description</label>
          <input
            id="itemDescription"
            name="itemDescription"
            type="text"
            placeholder="Describe the item or incident"
            value={form.itemDescription}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="amount">Amount</label>
          <div className="input-with-prefix">
            <span className="prefix">$</span>
            <input
              id="amount"
              name="amount"
              type="number"
              min="0"
              step="0.01"
              placeholder="0.00"
              value={form.amount}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <div className="form-group">
          <label htmlFor="incidentDate">Incident Date</label>
          <input
            id="incidentDate"
            name="incidentDate"
            type="date"
            value={form.incidentDate}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Upload Photos/Docs</label>
          <label className="file-upload-area" htmlFor="files">
            <input
              id="files"
              name="files"
              type="file"
              multiple
              accept="image/*,.pdf"
              onChange={handleChange}
              className="file-input-hidden"
            />
            <span className="file-upload-placeholder">📷 Tap to upload files</span>
          </label>
        </div>

        <button type="submit" className="btn btn-primary btn-submit">
          Submit Claim
        </button>
      </form>
    </div>
  );
}
